
function getGATrackingID(){
    if (window.location.hostname === 'dev-points.serban.pw' ||
                    window.location.hostname === 'localhost'){
        return "UA-126392552-1"
        }
    if (window.location.hostname === 'points-o-rama.serban.pw'){
        return "UA-126473247-1"
    }
    return null;
}

export default getGATrackingID;


// WEBPACK FOOTER //
// ./src/helpers/getGATrackingID.js